var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { Observable, from } from 'rxjs';
import html2canvas from 'html2canvas';
import * as i0 from "@angular/core";
export var ImageTypeEnum;
(function (ImageTypeEnum) {
    ImageTypeEnum["JPEG"] = "image/jpeg";
    ImageTypeEnum["PNG"] = "image/png";
})(ImageTypeEnum || (ImageTypeEnum = {}));
var ImageService = /** @class */ (function () {
    function ImageService() {
    }
    ImageService.prototype.canvasToBlob = function (canvas, contentType, quality) {
        var _this = this;
        return new Observable(function (observer) {
            if (canvas.toBlob) { // native toBlob support
                canvas.toBlob(function (blob) {
                    observer.next(blob);
                    observer.complete();
                }, contentType, quality);
            }
            else { // fallback support
                var imageData = canvas.toDataURL(contentType, quality);
                var blob = _this.base64ToBlob(imageData, contentType);
                observer.next(blob);
                observer.complete();
            }
        });
    };
    ImageService.prototype.fitCanvas = function (canvas, _a) {
        var width = _a.width, height = _a.height;
        var thumbnailCanvas = document.createElement('canvas');
        thumbnailCanvas.width = width;
        thumbnailCanvas.height = height;
        var thumbnailContext = thumbnailCanvas.getContext('2d');
        // calculate source width and height dimensions
        var thumbanilAspect = thumbnailCanvas.width / thumbnailCanvas.height;
        var sourceHeight = canvas.height;
        var sourceWidth = thumbanilAspect * sourceHeight;
        // calculate source offset
        var offsetX = 0.5 * (canvas.width - sourceWidth);
        // render 3D frame and transfer to thumbnail canvas
        return new Observable(function (observer) {
            thumbnailContext.drawImage(canvas, offsetX, 0, sourceWidth, sourceHeight, 0, 0, thumbnailCanvas.width, thumbnailCanvas.height);
            observer.next(thumbnailCanvas);
            observer.complete();
        });
    };
    ImageService.prototype.elementToCanvas = function (element, transparent) {
        if (transparent === void 0) { transparent = false; }
        var options = transparent ? { backgroundColor: 'transparent' } : {};
        return from(html2canvas(element, options));
    };
    ImageService.prototype.combineCanvasElements = function (canvasElements) {
        // calculate max bounds
        var width = Math.max.apply(Math, __spread([0], canvasElements.map(function (canvas) { return canvas.width; })));
        var height = Math.max.apply(Math, __spread([0], canvasElements.map(function (canvas) { return canvas.height; })));
        var targetCanvas = document.createElement('canvas');
        targetCanvas.width = width;
        targetCanvas.height = height;
        // get 2D context for painting each image
        var targetContext = targetCanvas.getContext('2d');
        // paint each canvas to top left, ordered
        canvasElements.forEach(function (canvas) {
            targetContext.drawImage(canvas, 0, 0);
        });
        return targetCanvas;
    };
    ImageService.prototype.base64ToBlob = function (imageData, contentType) {
        var byteString = atob(imageData.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: contentType });
    };
    ImageService.prototype.blobToBase64 = function (blob) {
        return new Observable(function (observer) {
            var reader = new FileReader();
            reader.addEventListener('load', function () {
                observer.next(reader.result);
                observer.complete();
            });
            reader.readAsDataURL(blob);
        });
    };
    ImageService.prototype.blobToCanvas = function (blob, _a) {
        var width = _a.width, height = _a.height;
        return new Observable(function (observer) {
            var canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            var context = canvas.getContext('2d');
            var img = new Image();
            img.addEventListener('load', function () {
                context.drawImage(img, 0, 0);
                observer.next(canvas);
                observer.complete();
            });
            img.src = URL.createObjectURL(blob);
        });
    };
    ImageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ImageService_Factory() { return new ImageService(); }, token: ImageService, providedIn: "root" });
    return ImageService;
}());
export { ImageService };
